<template>
  <d-card class="card-small mb-5">
    <spinner-dot v-if="loading" />
    <div v-else>
      <div class="header-data-table">
        <h5 class="header-data-table__heading">{{ $t("minibus.history.title") }}</h5>
      </div>
      <data-table
        :data="minibusGridData"
        :fields="gridColumnsTitle"
        :selectedFields="minibusFields"
        :fieldsGrid="gridColumnsFields"
        :tableState="state"
        :count="count"
      ></data-table>
    </div>
  </d-card>
</template>

<script>
import SpinnerDot from "../layout/Loading/spinner-dot";
import DataTable from "../dataTable/dataTable";
import minibusRequestGrid from "../../data/dataTable/minibusRequestGrid.json";
import TimeUtils from '../../utils/TimeUtils';

export default {
  name: "HistoryMinibus",
  components: {
    DataTable,
    SpinnerDot,
  },
  props: ["reference"],
  data() {
    return {
      requestHistory: [],
      count: 0,
      model: {},
      // all values available for the table
      gridColumnsFields: minibusRequestGrid.grid,
      gridColumnsTitle: minibusRequestGrid.grid.map(grid => grid.title),
      loading: true,
      minibusFields: [
        "Titre",
        "Destination",
        "Date de début",
        "Date de fin",
        "Status"
      ],
      hours: [
                '00',
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
            ],
      minibusFieldsGridFill: {
        "Titre": request => request.title,
        "Destination": request => request.destination,
        "Date de début": request => new Date(request.fromDate).toLocaleDateString("fr-FR") + `  (${this.hours[parseInt(request.fromDate.split('T')[1].split(':')[0]) + 1]}:${new Date(request.fromDate).getMinutes() ? new Date(request.fromDate).getMinutes() : "00"})`,
        "Date de fin": request => new Date(request.toDate).toLocaleDateString("fr-FR")  + `  (${this.hours[parseInt(request.toDate.split('T')[1].split(':')[0]) + 1]}:${new Date(request.toDate).getMinutes() ? new Date(request.toDate).getMinutes() : "00"})`,
        "Status": request => request.answers[0].status || "En attente...",
      },
      state: {
        page: 1,
        perPage: 10,
        field: "creationDate",
        ascending: false
      },
    };
  },

  watch: {
    state: {
      handler() {
        this.minibusFetch();
      },
      deep: true
    },
  },

  computed: {
    user() {
      return this.$store.state.user.informations;
    },
    minibusGridData() {
      return this.requestHistory.map((user) => {
        const res = {};
        this.minibusFields.forEach((field) => {
          if (this.minibusFieldsGridFill[field]) {
            res[field] = this.minibusFieldsGridFill[field](user);
          }
        });
        return res;
      });
    },
  },

  methods: {
    async minibusFetch() {
      this.loading = true;
      await this.$services.minibusRequest
        .findMine(
          this.user.reference,
          null,
          null,
          null,
          this.state.page,
          this.state.perPage,
          this.state.field,
          this.state.ascending,
          this.gridColumnsFields
        )
        .then(res => {
          this.loading = false;
          this.count = res.data.count;
          this.requestHistory = res.data.data;
        });
    },
    formatTime(date) {
      return TimeUtils.formatTime(date);
    },
  },

  mounted() {
    if (!this.reference) {
      this.model = { userReference: this.user.reference };
    } else {
      this.model = { userReference: this.reference };
    }
    this.minibusFetch();
  }
};
</script>
